<template>
  <div v-if="item" class="message-card" @click="go2()">
    <div :class="typeSize === 2 ? 'message max' : 'message min'">
      <div class="message-left">
        <div class="time year">{{ item.time[0] }}</div>
        <div class="time day">{{ item.time[1] }}/{{ item.time[2] }}</div>
      </div>
      <div
        :class="
          typeSize === 2 ? 'message-content max1' : 'message-content max2'
        "
      >
        <div :class="typeSize === 2 ? 'title' : 't-size'">{{ item.name }}</div>
        <div  :class="typeSize === 2 ? 'content' : ' c-size'" v-text="filtersText(item.content.replace(/&nbsp;/g, ''))">
         <!-- {{filtersText(item.content)}} -->;
        </div>
        <div :class="typeSize === 2 ? 'message-img' : 'message-img-none'">
          <img
            :src="
              imgUrl(item.picture) ||
              (idx == 0
                ? require('../assets/image/guide.png')
                : idx == 1
                ? require('../assets/image/guide2.png')
                : require('../assets/image/guide3.png'))
            "
            alt=""
          />
        </div>
      </div>
      <div class="message-right">
        <div class="more">></div>
      </div>
    </div>
  </div>

  <!-- <div class="jump">
      <span>了解更多 > </span>
    </div> -->
</template>
<script>
export default {
  props: {
    none: Number,
    typeSize: Number,
    idx: {
      type: Number,
      // required: true,
      default: 0,
    },
    item: {
      type: Object,
      // required: true,
      default: null,
    },
  },
  methods: {
    go2() {
      this.$router.push(`/datails?id=${this.item.id}`);
    },
  },
};
</script>

<style>
.c-size p {
  text-indent: 0;
  /* margin: -10px 0 0 0; */
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
}
.c-size p:not(:first-child) {
  display: none;
}
</style>


<style lang="scss" scoped>
.message-card:first-child {
  margin: 0;
  @media (max-width: 800px) {
    margin: 0 auto;
  }
}

.message-card {
  // width: 80%;
  height: 141px;
  margin: 22px 0 0 0;
  // display: inline;
  @media (max-width: 800px) {
    width: 98%;
    margin: 25px auto;
  }
  .message {
    float: left;
    display: flex;
    justify-content: space-between;
    width: 100%;
    // height: 141px;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.1);

    cursor: pointer;
    @media (max-width: 800px) {
      margin: 0 auto;
      width: 100%;
      display: -webkit-box;
      -webkit-box-pack: start;
      // float: none;
    }
    .message-left {
      width: 143px;
      height: 143px;
      @media (max-width: 800px) {
        width: 100px;
      }
      @media (max-width: 300px) {
        width: 80px;
      }
      .time {
        font-family: Microsoft YaHei, Microsoft YaHei !important;
      }
      .year {
        padding: 33px 0 0 24px;
        font-weight: 400;
        font-size: 14px;
        color: #464646;
        // line-height: 24px;
        @media (max-width: 300px) {
          padding: 33px 0 0 16px;
        }
      }
      .day {
        margin: 8px 0 0 24px;
        font-weight: bold;
        font-size: 25px;
        color: #162a46;
        // line-height: 43px;
        @media (max-width: 800px) {
          font-size: 16px;
        }
        @media (max-width: 300px) {
          margin: 8px 0 0 16px;
        }
      }
    }
    .message-content {
      // width: 85%;

      @media (max-width: 1200px) {
        // max-width: 450px;
        width: 76%;
        float: left;
      }
      @media (max-width: 800px) {
        // max-width: 450px;
        width: 77%;
        float: left;
      }
      @media (max-width: 400px) {
        width: 65%;
      }
      @media (max-width: 330px) {
        // max-width: 450px;
        width: 60%;
      }

      .title {
        width: 72%;
        height: 26px;
        float: left;
        margin: 24px 0 0 0;
        font-family: Microsoft YaHei, Microsoft YaHei !important;
        font-weight: bold;
        font-size: 20px;
        color: #d04f5d;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        @media (max-width: 1200px) {
          width: 100%;
        }
        @media (max-width: 800px) {
          font-size: 18px !important;
          width: 100%;
        }
        @media (max-width: 800px) {
          width: 80%;
        }

        @media (max-width: 300px) {
          margin-top: 20px;
          margin-bottom: 10px;
          font-size: 16px !important;
        }
      }
      .content {
        // 大内容
        width: 80%;
        height: 60px;
        float: left;
        margin: 10px 0 0 0;
        font-family: Microsoft YaHei, Microsoft YaHei !important;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        overflow: hidden;
        display: -webkit-box; /* 使用弹性盒子布局模型 */
        -webkit-box-orient: vertical; /* 垂直排列子元素 */
        -webkit-line-clamp: 3; /* 限制在三行 */
        line-clamp: 3; /* 非WebKit浏览器的兼容写法 */
        text-overflow: ellipsis;
        @media (max-width: 1520px) {
          width: 79%;
        }
        @media (max-width: 1366px) {
          width: 72%;
        }
        @media (max-width: 1200px) {
          width: 95%;
        }
        @media (max-width: 800px) {
          width: 93%;
          // margin: 0;
          font-size: 14px !important;
        }
        @media (max-width: 400px) {
          width: 90%;
        }
        @media (max-width: 300px) {
          width: 100%;
          margin: 0;
          font-size: 14px !important;
        }
      }
      .t-size {
        // 短
        width: 98%;
        height: 26px;
        margin: 24px 0 0 0;
        font-family: Microsoft YaHei, Microsoft YaHei !important;
        font-weight: bold;
        font-size: 20px;
        color: #d04f5d;
        line-height: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        @media (max-width: 800px) {
          font-size: 16px !important;
          // width: 98%;
          width: 80%;
        }
      }
      .c-size {
        // 小内容
        width: 98%;
        height: 70px;
        font-family: Microsoft YaHei, Microsoft YaHei !important;
        // margin: -30px 0 0 15px;
        font-size: 14px;
        margin: 10px 0 0 0;
        line-height: 24px;
        overflow: hidden;
        display: -webkit-box; /* 使用弹性盒子布局模型 */
        -webkit-box-orient: vertical; /* 垂直排列子元素 */
        -webkit-line-clamp: 3; /* 限制在三行 */
        line-clamp: 3; /* 非WebKit浏览器的兼容写法 */
        text-overflow: ellipsis;

        @media (max-width: 800px) {
          font-size: 14px !important;
          // width: 98%;
          width: 89%;
        }
        @media (max-width: 300px) {
          font-size: 14px !important;
          width: 100%;
          line-height: 20px;
        }
      }
      .message-img {
        width: 168px;
        height: 100%;
        margin-right: 10px;
        display: flex;
        padding-left: 2.5%;
        align-items: center;
        justify-content: end;
        @media (max-width: 1366px) {
          width: 20%;
        }
        img {
          float: right;
        }
        @media (max-width: 1366px) {
        }
        @media (max-width: 1200px) {
          display: none;
        }
        @media (max-width: 800px) {
          display: none;
        }
      }
      .message-img-none {
        display: none;
      }
    }
    .message-right:hover .more {
      transform: translateX(2px);
    }
    .message-right {
      margin: 0 0 0 0;
      width: 41px;
      height: 143px;
      background-color: #cd0908;
      // display: none;
      // transition: background-color 1s ease;
      // transition-delay: 0.8s; /* 设置延迟时间为0.5秒 */
      transition-property: opacity;
      transition-duration: 1s;
      opacity: 0;
      @media (max-width: 800px) {
        display: none;
      }
      .more {
        width: 8px;
        height: 143px;
        margin-left: 18px;
        line-height: 143px;
        font-size: 16px;
        color: #fff;
        transition: transform 0.5s ease;
        max-width: 100%;
      }
    }
  }
  .message:hover .message-right {
    // display: block;
    opacity: 1;
  }
  .max {
    width: 100%;

    @media (max-width: 1200px) {
      width: 100%;
    }
    @media (max-width: 800px) {
      width: 100%;
      float: left;
    }
  }
  .max1 {
    width: 88%;
    @media (max-width: 1366px) {
      width: 84%;
    }
  }
  .min {
    width: 100%;

    @media (max-width: 800px) {
      width: 75%;
    }
    @media (max-width: 800px) {
      // max-width: 450px;
      width: 100%;
      float: none;
    }
  }
  .max2 {
    width: 72%;
    @media (max-width: 1600px) {
      width: 67%;
    }
    @media (max-width: 1366px) {
      width: 77%;
    }
  }
  .min > .message-content > .c-size {
    // margin: 0;
    height: 66px;
    @media (max-width: 300px) {
      height: 61px;
    }
  }
}
.message-card:first-child div {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/MessageCard.vue